/**
 * @generated SignedSource<<762213f00613c977e4a7ee465d0cd473>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftDraftItemTileDetails_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NftItemTileTooltip_viewer">;
  readonly " $fragmentType": "NftDraftItemTileDetails_viewer";
};
export type NftDraftItemTileDetails_viewer$key = {
  readonly " $data"?: NftDraftItemTileDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftDraftItemTileDetails_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftDraftItemTileDetails_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftItemTileTooltip_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "2b058a38972a6c8763159405e3e4dcb7";

export default node;
